import { savedFilterType } from "./savedFilter.types";

export const prepareFilterOptions = (savedFilter: savedFilterType) => {
  const cleanedObj = { ...savedFilter };
  delete cleanedObj.createdOn;
  delete cleanedObj.updatedOn;
  delete cleanedObj.userBackOfficeID;
  delete cleanedObj.userBoId;
  delete cleanedObj.userRoleCode;

  for (const key in cleanedObj) {
    if (cleanedObj[key] === null) {
      delete cleanedObj[key];
    }
  }
  return cleanedObj;
};
